// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------
export const PUBLIC_PATH = {
  appInfo: '/appInfo',
  inquiry: '/inquiry',
  poopData: '/poop-data',
  poopDataPurchase: '/poop-data/purchase',
  poopDataPurchaseComplete: '/poop-data/purchase/complete',
  idcard: {
    create: '/idcard/create',
    carddetail: '/idcard/carddetail',
  },
  board: {
    root: '/notice',
    details: (id: string | number) => `/board/${id}`,
  },

  feed: {
    search: '/feed/search',
    request: '/feed/food-request',
    requestComplete: '/feed/food-request/complete',
    details: (uuid: string) => `/feed/${uuid}`,
  },

  share: {
    verifyRoute: '/share/:hisUrl',
    dataRoute: '/share/:hisUrl/data',
    verify: (hisUrl: string) => `/share/${hisUrl}`,
    data: (hisUrl: string) => `/share/${hisUrl}/data`,
  },

  // 약관
  terms: {
    root: '/terms',
    privacy: '/terms/privacy',
    used: '/terms/used',
    loc: '/terms/loc',
    pay: '/terms/pay',
  },
};

export const PRIVATE_PATH = {
  dashboard: {
    root: ROOTS.DASHBOARD,
    home: ROOTS.DASHBOARD,
    statistics: {
      root: `${ROOTS.DASHBOARD}/statistics`,
      list: `${ROOTS.DASHBOARD}/statistics/list`,
    },
    notices: {
      root: `${ROOTS.DASHBOARD}/notices`,
      new: `${ROOTS.DASHBOARD}/notices/new`,
      details: (uid: string | number) => `${ROOTS.DASHBOARD}/notices/${uid}`,
      edit: (uid: string | number) => `${ROOTS.DASHBOARD}/notices/${uid}/edit`,
    },
    blog: {
      root: `${ROOTS.DASHBOARD}/blog`,
      new: `${ROOTS.DASHBOARD}/blog/new`,
      details: (uid: string | number) => `${ROOTS.DASHBOARD}/blog/${uid}`,
      edit: (uid: string | number) => `${ROOTS.DASHBOARD}/blog/${uid}/edit`,
    },
    guide: {
      root: `${ROOTS.DASHBOARD}/guide`,
      new: `${ROOTS.DASHBOARD}/guide/new`,
      details: (uid: string | number) => `${ROOTS.DASHBOARD}/guide/${uid}`,
      edit: (uid: string | number) => `${ROOTS.DASHBOARD}/guide/${uid}/edit`,
    },
    event: {
      root: `${ROOTS.DASHBOARD}/event`,
      new: `${ROOTS.DASHBOARD}/event/new`,
      details: (uid: string | number) => `${ROOTS.DASHBOARD}/event/${uid}`,
      edit: (uid: string | number) => `${ROOTS.DASHBOARD}/event/${uid}/edit`,
    },
    terms: {
      root: `${ROOTS.DASHBOARD}/terms`,
      new: `${ROOTS.DASHBOARD}/terms/new`,
      details: (uid: string | number) => `${ROOTS.DASHBOARD}/terms/${uid}`,
      edit: (uid: string | number) => `${ROOTS.DASHBOARD}/terms/${uid}/edit`,
    },
    notiHis: {
      root: `${ROOTS.DASHBOARD}/noti-his`,
      list: `${ROOTS.DASHBOARD}/noti-his/list`,
      new: `${ROOTS.DASHBOARD}/noti-his/new`,
    },
    email: {
      root: `${ROOTS.DASHBOARD}/email`,
      list: `${ROOTS.DASHBOARD}/email/list`,
      new: `${ROOTS.DASHBOARD}/email/new`,
    },
  },
};

export const paths = {
  components: '/components',
  docs: 'https://docs.minimals.cc/',
  // AUTH
  auth: {
    jwt: {
      signIn: `${ROOTS.AUTH}/jwt/sign-in`,
    },
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    notiHis: {
      list: `${ROOTS.DASHBOARD}/noti-his/list`,
    },
    email: {
      list: `${ROOTS.DASHBOARD}/email/list`,
      new: `${ROOTS.DASHBOARD}/email/new`,
    },
  },
};
